import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const CategoriesService = {
  async getAllCategoreis() {
    let response = await $axios.get($api("categories")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getAllLeafCategoreis() {
    let response = await $axios.get($api("categories_leaf")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getCategoryChild(id: any) {
    let response = await $axios
      .get($api("categories_child_id", { id }))
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addCategory(payload: any) {
    try {
      const { data, status } = await $axios.post($api("categories"), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
  async updateCategory(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("categories_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteCategory(id: number) {
    try {
      const { data, status } = await $axios.delete(
        $api("categories_id", { id }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
};
